import Reveal from "@/components/base/Reveal";
import { collections } from "@/mocks/home";

export default function CollectionIndex() {
  return (
    <section id="collections" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-10 md:px-6 md:py-14">
        <Reveal>
          <div className="overflow-hidden rounded-lg border border-secondary-200 bg-secondary-50">
            <div className="grid grid-cols-1 lg:grid-cols-12">
              <div className="border-b border-secondary-200 p-6 md:p-8 lg:col-span-4 lg:border-b-0 lg:border-r">
                <span className="inline-flex items-center gap-1.5 text-[11px] font-label tracking-[0.22em] text-accent-700">
                  <i className="ri-links-line text-xs" />
                  INDEX · 合集索引
                </span>
                <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-[30px]">
                  想顺着一条线挖到底，从这里进
                </h2>
                <p className="mt-3 text-xs leading-relaxed text-secondary-900 md:text-sm">
                  合集把散落的记录按主题归拢：同一组人物、同一段时间、同一类分歧。进去之后，每一篇都能回到原始线索。
                </p>

                <div className="mt-6 space-y-3 border-t border-secondary-200 pt-5">
                  <div className="flex items-center gap-2 text-xs text-secondary-900">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-stack-line text-sm text-accent-600" />
                    </span>
                    共 5 个合集 · 54 篇留档
                  </div>
                  <div className="flex items-center gap-2 text-xs text-secondary-900">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-history-line text-sm text-accent-600" />
                    </span>
                    最近更新：2026.09.10
                  </div>
                </div>
              </div>

              <ul className="lg:col-span-8">
                {collections.map((item, i) => (
                  <li
                    key={item.name}
                    className={`border-secondary-200 ${
                      i === 0 ? "" : "border-t"
                    }`}
                  >
                    <a
                      href="#archive"
                      className="group flex cursor-pointer items-center gap-4 px-5 py-4 transition-colors hover:bg-secondary-100/70 md:px-7 md:py-5"
                    >
                      <span className="w-6 shrink-0 font-heading text-base font-black text-accent-600 md:text-lg">
                        {item.index}
                      </span>
                      <div className="h-12 w-12 shrink-0 overflow-hidden rounded-md border border-secondary-200 md:h-14 md:w-14">
                        <img
                          src={item.image}
                          alt={`${item.name} 黑料91扒皮 黑料91深扒`}
                          title={`黑料91扒皮 ${item.name}`}
                          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                      <div className="min-w-0 flex-1">
                        <h4 className="font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                          <a href="#archive" className="cursor-pointer">
                            {item.name}
                          </a>
                        </h4>
                        <p className="mt-1 truncate text-[11px] text-secondary-800 md:text-xs">
                          {item.desc}
                        </p>
                      </div>
                      <span className="hidden shrink-0 rounded-md bg-background-50 px-2 py-0.5 text-[11px] font-medium text-secondary-900 sm:inline-block">
                        {item.count}
                      </span>
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center text-secondary-600 transition-transform group-hover:translate-x-0.5">
                        <i className="ri-arrow-right-s-line text-lg" />
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}